const esTranslations = {
  translations: {
    pageTitle: "Autenticación Housien",

    help: {
      nextButton: "Siguiente",
      backButton: "Volver",
      defaultSelect: "Seleccione una opción...",
      showPasswordCheck: "Mostrar contraseña",
      timeForNewCodeText: "Recibir nuevo código",
      timeForNewCodeLink: "Enviar nuevo código",
      check: "Marque la casilla para continuar.",
      fieldOrSelect: "El campo {{placeholder}} es obligatorio.",
      toggleTheme: "Cambiar tema",
      toggleThemeToDark: "Cambiar a modo oscuro",
      toggleThemeToLight: "Cambiar a modo claro",
      requiredField: "Campo obligatorio",
      noOptionsFound: "No se encontraron opciones.",
      noCountriesFound: "No se encontraron países.",
      timeForNewCodeCountdown: "({{seconds}} segundos)",
      recaptchaWaiting: "Espere a que se complete la verificación de seguridad...",
      clientLogoAlt: "Logo del cliente",
      k4dLogoAlt: "Logo K4D",
      housienLogoAlt: "Logo Housien",
      closeAriaLabel: "Cerrar",
      and: "y",
    },

    error: {
      pageTitle: "Error",
      oauth: {
        title: "¡Ups! Algo salió mal",
        message: "No pudimos procesar su solicitud. Verifique si el enlace de acceso es correcto e intente nuevamente.",
        cta: "Intentar de nuevo",
        missing: "Faltan parámetros obligatorios: {{params}}",
        invalid: "Los parámetros proporcionados son inválidos o están incompletos.",
        clientInvalid: "El client_id proporcionado no es válido o no está registrado en el sistema.",
        providerError: "Código de error: {{code}}\nMensaje: {{message}}",
        unexpected: "Error inesperado."
      },
      recaptcha: {
        details: "Nuestro servicio anti-bot no responde correctamente. Por favor, intente nuevamente más tarde.",
        tokenRequired: "Se requiere el token anti-bot para la solicitud de autenticación. Asegúrese de que reCAPTCHA se haya ejecutado antes de realizar esta solicitud.",
        tokenNotAvailable: "Se requiere el token anti-bot pero no está disponible. Asegúrese de que reCAPTCHA se haya ejecutado.",
        notReady: "reCAPTCHA no está listo. Espere a que se complete la inicialización.",
        userFacing: "La verificación de seguridad falló. Espere unos segundos e intente nuevamente.",
        retry: "Intentar de nuevo"
      },
      antiBot: {
        InvalidTokenError: "La validación de seguridad falló. Actualice la página e intente nuevamente.",
        MissingTokenError: "La verificación de seguridad no se completó. Actualice la página e intente nuevamente."
      },
      social: {
        title: "Inicio de Sesión Social No Disponible",
        message: "Su cuenta social no tiene una dirección de correo electrónico verificada, que es necesaria para iniciar sesión.",
        details: "Para continuar, agregue y verifique una dirección de correo electrónico en su proveedor social (Google, Facebook, etc.) e intente iniciar sesión nuevamente.",
        cta: "Volver al inicio de sesión"
      },
      route: {
        title: "Página no encontrada",
        message: "La página que busca no existe o ha sido movida. Verifique la dirección e intente nuevamente.",
        path: "Ruta solicitada: {{path}}",
        cta: "Volver"
      },
      timeout: {
        title: "Tiempo de espera agotado",
        message: "El servidor no responde. Espere unos momentos e intente nuevamente.",
        details: "Se excedió el tiempo límite de 1 minuto mientras se esperaba una respuesta del servidor.",
        cta: "Reintentar"
      },
      general: {
        title: "Algo salió mal",
        message: "Ocurrió un error inesperado. Intente nuevamente en unos momentos.",
        missing: "Argumentos obligatorios: {{params}}",
        altText: "Ilustración de error",
        cta: "Volver"
      },
      clientNotFound: {
        title: "Cliente no encontrado",
        message: "El Client ID {{clientId}} no está registrado.",
        networkError: "Error de red, verifique su conexión."
      },
      help: "Lamentamos las molestias. Si el problema persiste, comuníquese con soporte.",
      details: {
        show: "Ver detalles técnicos",
        hide: "Ocultar detalles técnicos"
      },
      token: {
        expired: "El token de autenticación ha expirado. Actualice la página.",
        expiringSoon: "El token expira en {{timeString}}. Complete su acción pronto."
      },
      recoveryPassword: {
        missingToken: "Falta el token de recuperación. Use un enlace de recuperación válido.",
        invalidLinkTitle: "Enlace de Recuperación Inválido"
      },
      runtime: {
        redirectFailed: "Error al redirigir después de la autenticación. Intente nuevamente.",
        unexpectedPasswordResponse: "Tipo de respuesta inesperado de la autenticación por contraseña. Intente nuevamente.",
        unexpectedSecondFactorResponse: "Tipo de respuesta inesperado de la autenticación de segundo factor. Intente nuevamente.",
        requestTimeout: "La solicitud ha expirado. Intente nuevamente.",
        networkError: "Error de red: verifique su conexión e intente nuevamente.",
        maxRecoverySends: "Se alcanzó el máximo de envíos de enlaces de recuperación. Contacte a los administradores del sistema.",
        recoveryCooldown: "Espere {{seconds}} segundos antes de enviar otro enlace de recuperación de contraseña.",
        requestInProgress: "Solicitud en curso.",
        noIdentityToken: "No se encontró un token de identidad válido. Complete el paso de identidad primero.",
        oauth2Required: "Se requiere la información del cliente OAuth2. Asegúrese de que se proporcionen los parámetros OAuth2.",
        missingRecoveryParams: "Faltan parámetros de recuperación obligatorios. Use un enlace de recuperación válido.",
        invalidAuthToken: "Token de autenticación inválido o expirado.",
        recaptchaUnavailable: "reCAPTCHA no está disponible.",
        recaptchaFailed: "Error al obtener el token anti-bot de reCAPTCHA.",
        recaptchaNotReadyTimeout: "reCAPTCHA no se activó dentro del tiempo límite. Actualice la página.",
        noIdentityResponse: "No se encontró respuesta de identidad.",
        noPersonalInfoResponse: "No se encontró respuesta de información personal.",
        noPasswordResponse: "No se encontró respuesta de contraseña.",
        requestCancelled: "La solicitud fue cancelada.",
        antiBotRequired: "Se requiere el token anti-bot para la solicitud de autenticación.",
      }
    },

    login: {
      identity: {
        pageTitle: "Iniciar Sesión",
        title: "Iniciar sesión",
        subtitle: "Use su cuenta para acceder a nuestros servicios.",
        subtitleTemplate: "Use su cuenta {{clientName}} para acceder a nuestros servicios.",
        emailPlaceholder: "Correo electrónico",
        emailPlaceholderHint: "su@correo.com",
        forgotEmailLink: "¿Olvidó su correo?",
        guestModeText: "¿No es su computadora? Use el modo invitado para iniciar sesión de forma privada.",
        guestModeLink: "¡Más detalles, por favor!",
        createAccountButton: "Crear cuenta",
        nextButton: "Siguiente",
        orConnectWithText: "o",
        continueWithGoogle: "Continuar con Google",
        continueWithFacebook: "Continuar con Facebook",
        continueWithApple: "Continuar con Apple",
        googleUnavailable: "La autenticación con Google no está disponible temporalmente. Intente más tarde o use otro método de inicio de sesión.",
        facebookUnavailable: "La autenticación con Facebook no está disponible temporalmente. Intente más tarde o use otro método de inicio de sesión.",
        appleUnavailable: "La autenticación con Apple no está disponible temporalmente. Intente más tarde o use otro método de inicio de sesión.",
        recaptchaNotice: "Protegido por reCAPTCHA. Se aplican la Política de Privacidad y los Términos de Servicio de Google.",
      },

      password: {
        pageTitle: "Contraseña",
        title: "Hola, {{username}}",
        subtitle: "Confirme su identidad",
        passwordPlaceholder: "Contraseña",
        forgotPasswordLink: "¿Olvidó su contraseña?",
        securityWarning: "Nunca comparta su contraseña con terceros. Housien nunca solicita su contraseña por teléfono, correo electrónico o WhatsApp.",
        securityWarningLink: "Más información sobre seguridad.",
      },

      sendRecoveryPasswordLink: {
        pageTitle: "Recuperar Contraseña",
        title: "¿Olvidó su contraseña?",
        subtitle: "Cree una nueva contraseña siguiendo las instrucciones",
        text: "Enviamos un enlace al correo {{email}}, acceda a este enlace para crear una nueva contraseña.",
        initialText: "Haga clic en el botón de abajo para enviar un enlace de recuperación de contraseña a su correo {{email}}.",
        timeLabel: "Recibir nuevo enlace",
        linkLabel: "Enviar nuevo enlace",
        buttonText: "Enviar enlace de recuperación",
        buttonWaitText: "Espere {{seconds}} segundos",
        buttonSendingText: "Enviando...",
        buttonMaxReachedText: "Máximo de envíos alcanzado",
        cooldownMessage: "Puede enviar otro enlace de recuperación en {{seconds}} segundos.",
        sendCountMessage: "Enlaces de recuperación enviados: {{count}}/3",
        maxSendsMessage: "No es posible enviar un nuevo enlace de recuperación. Contacte a los administradores del sistema.",
        recoveryLinkSentTitle: "Enlace de Recuperación Enviado"
      },

      recoveryPassword: {
        pageTitle: "Nueva Contraseña",
        title: "Crear nueva contraseña",
        subtitle: "Ingrese y confirme una nueva contraseña para acceder a su cuenta"
      },

      secondFactor: {
        pageTitle: "Autenticación en Dos Factores",
        title: "Verificación de Dos Factores",
        subtitle: "Ingrese el código de verificación enviado a su correo electrónico",
        codePlaceholder: "Ingrese el código"
      }
    },

    signup: {
      createAccount: {
        pageTitle: "Crear Cuenta",
        title: "Crear una Cuenta Housien",
        subtitle: "Ingrese su nombre y nacionalidad",
        namePlaceholder: "Nombre",
        surnamePlaceholder: "Apellido (opcional)",
        nationalityPlaceholder: "¿De dónde es?",
        serviceTermsCheck: "Acepto los",
        serviceTermsLink: "Términos de Servicio",
        privacyPolicyLink: "Política de Privacidad",
        loginButton: "¿Ya tiene cuenta?",
      },

      birthdayGender: {
        pageTitle: "Información Personal",
        title: "Información básica",
        subtitle: "Ingrese su fecha de nacimiento y género",
        dayPlaceholder: "Día",
        monthPlaceholderSelect: "Mes",
        monthPlaceholderSelectOptions:
          "Enero,Febrero,Marzo,Abril,Mayo,Junio,Julio,Agosto,Septiembre,Octubre,Noviembre,Diciembre",
        yearPlaceholder: "Año",
        genderPlaceholderSelect: "Género",
        genderPlaceholderSelectOptions: "Femenino,Masculino,Personalizado,Prefiero no decir",
        genderPlaceholder: "¿Cuál es su género?",
        pronounPlaceholderSelect: "Refiérase a mí como",
        pronounPlaceholderSelectOptions: "Femenino,Masculino,Otro",
      },

      insertUsername: {
        pageTitle: "Elegir Correo",
        title: "Cómo iniciará sesión",
        subtitle: "Ingrese una dirección de correo electrónico para iniciar sesión en su Cuenta Housien",
        emailPlaceholder: "Correo electrónico",
      },

      createPassword: {
        pageTitle: "Crear Contraseña",
        title: "Crear una Contraseña",
        subtitle:
          "Cree una contraseña segura con una combinación de letras, números y símbolos",
        passwordPlaceholder: "Contraseña",
        confirmPasswordPlaceholder: "Confirmar Contraseña",
      },

      insertUsernameCode: {
        pageTitle: "Verificar Correo",
        title: "Verifique su Correo Electrónico",
        subtitle:
          "Felicitaciones por crear su Cuenta Housien. Ahora ingrese el código de verificación enviado al correo electrónico ingresado",
        codePlaceholder: "Ingrese el código",
      },

      congratulations: {
        pageTitle: "¡Bienvenido!",
        title: "Cuenta Housien Creada",
        subtitle: "¡Felicitaciones por finalizar su Cuenta Housien!",
        bodyText:
          "Ahora conéctese con su cuenta para poder disfrutar de todos nuestros servicios.",
        loginLink: "Iniciar sesión",
      },

      onboarding: {
        pageTitle: "Completar Registro",
        title: "Bienvenido, {{name}}",
        subtitle: "Un último paso para comenzar.",
        body: "Al continuar, permites que K4D te envíe actualizaciones importantes sobre tu cuenta, alertas de seguridad y comunicaciones del servicio.",
      }
    },

    popUp: {
      titlePrefix: "Ups...",
      titleError: "Algo salió mal",
      titleNetworkError: "Sin conexión",
      bodyTextError: "No pudimos completar su solicitud. Intente nuevamente.",
      bodyTextNetworkError: "Verifique su conexión a internet e intente nuevamente.",
      bodyText:
        "Si el problema persiste, contáctenos proporcionando el código de error",
      contactSubtitle: "Contacto",
      moreDetailsLink: "Más Detalles",
      detailsToggle: "Detalles técnicos",
      dismissButton: "Intentar de nuevo",
    },

    countries: {
      AF: "Afganistán",
      AL: "Albania",
      DZ: "Argelia",
      AD: "Andorra",
      AO: "Angola",
      AG: "Antigua y Barbuda",
      AR: "Argentina",
      AM: "Armenia",
      AU: "Australia",
      AT: "Austria",
      AZ: "Azerbaiyán",
      BS: "Bahamas",
      BH: "Baréin",
      BD: "Bangladés",
      BB: "Barbados",
      BY: "Bielorrusia",
      BE: "Bélgica",
      BZ: "Belice",
      BJ: "Benín",
      BT: "Bután",
      BO: "Bolivia",
      BA: "Bosnia y Herzegovina",
      BW: "Botsuana",
      BR: "Brasil",
      BN: "Brunéi",
      BG: "Bulgaria",
      BF: "Burkina Faso",
      BI: "Burundi",
      CV: "Cabo Verde",
      KH: "Camboya",
      CM: "Camerún",
      CA: "Canadá",
      CF: "República Centroafricana",
      TD: "Chad",
      CL: "Chile",
      CN: "China",
      CO: "Colombia",
      KM: "Comoras",
      CG: "Congo",
      CD: "República Democrática del Congo",
      CR: "Costa Rica",
      CI: "Costa de Marfil",
      HR: "Croacia",
      CU: "Cuba",
      CY: "Chipre",
      CZ: "República Checa",
      DK: "Dinamarca",
      DJ: "Yibuti",
      DM: "Dominica",
      DO: "República Dominicana",
      EC: "Ecuador",
      EG: "Egipto",
      SV: "El Salvador",
      GQ: "Guinea Ecuatorial",
      ER: "Eritrea",
      EE: "Estonia",
      SZ: "Esuatini",
      ET: "Etiopía",
      FJ: "Fiyi",
      FI: "Finlandia",
      FR: "Francia",
      GA: "Gabón",
      GM: "Gambia",
      GE: "Georgia",
      DE: "Alemania",
      GH: "Ghana",
      GR: "Grecia",
      GD: "Granada",
      GT: "Guatemala",
      GN: "Guinea",
      GW: "Guinea-Bisáu",
      GY: "Guyana",
      HT: "Haití",
      HN: "Honduras",
      HU: "Hungría",
      IS: "Islandia",
      IN: "India",
      ID: "Indonesia",
      IR: "Irán",
      IQ: "Irak",
      IE: "Irlanda",
      IL: "Israel",
      IT: "Italia",
      JM: "Jamaica",
      JP: "Japón",
      JO: "Jordania",
      KZ: "Kazajistán",
      KE: "Kenia",
      KI: "Kiribati",
      KP: "Corea del Norte",
      KR: "Corea del Sur",
      KW: "Kuwait",
      KG: "Kirguistán",
      LA: "Laos",
      LV: "Letonia",
      LB: "Líbano",
      LS: "Lesoto",
      LR: "Liberia",
      LY: "Libia",
      LI: "Liechtenstein",
      LT: "Lituania",
      LU: "Luxemburgo",
      MG: "Madagascar",
      MW: "Malaui",
      MY: "Malasia",
      MV: "Maldivas",
      ML: "Malí",
      MT: "Malta",
      MH: "Islas Marshall",
      MR: "Mauritania",
      MU: "Mauricio",
      MX: "México",
      FM: "Micronesia",
      MD: "Moldavia",
      MC: "Mónaco",
      MN: "Mongolia",
      ME: "Montenegro",
      MA: "Marruecos",
      MZ: "Mozambique",
      MM: "Myanmar",
      NA: "Namibia",
      NR: "Nauru",
      NP: "Nepal",
      NL: "Países Bajos",
      NZ: "Nueva Zelanda",
      NI: "Nicaragua",
      NE: "Níger",
      NG: "Nigeria",
      MK: "Macedonia del Norte",
      NO: "Noruega",
      OM: "Omán",
      PK: "Pakistán",
      PW: "Palaos",
      PA: "Panamá",
      PG: "Papúa Nueva Guinea",
      PY: "Paraguay",
      PE: "Perú",
      PH: "Filipinas",
      PL: "Polonia",
      PT: "Portugal",
      QA: "Catar",
      RO: "Rumanía",
      RU: "Rusia",
      RW: "Ruanda",
      KN: "San Cristóbal y Nieves",
      LC: "Santa Lucía",
      VC: "San Vicente y las Granadinas",
      WS: "Samoa",
      SM: "San Marino",
      ST: "Santo Tomé y Príncipe",
      SA: "Arabia Saudita",
      SN: "Senegal",
      RS: "Serbia",
      SC: "Seychelles",
      SL: "Sierra Leona",
      SG: "Singapur",
      SK: "Eslovaquia",
      SI: "Eslovenia",
      SB: "Islas Salomón",
      SO: "Somalia",
      ZA: "Sudáfrica",
      SS: "Sudán del Sur",
      ES: "España",
      LK: "Sri Lanka",
      SD: "Sudán",
      SR: "Surinam",
      SE: "Suecia",
      CH: "Suiza",
      SY: "Siria",
      TW: "Taiwán",
      TJ: "Tayikistán",
      TZ: "Tanzania",
      TH: "Tailandia",
      TL: "Timor Oriental",
      TG: "Togo",
      TO: "Tonga",
      TT: "Trinidad y Tobago",
      TN: "Túnez",
      TR: "Turquía",
      TM: "Turkmenistán",
      TV: "Tuvalu",
      UG: "Uganda",
      UA: "Ucrania",
      AE: "Emiratos Árabes Unidos",
      GB: "Reino Unido",
      US: "Estados Unidos",
      UY: "Uruguay",
      UZ: "Uzbekistán",
      VU: "Vanuatu",
      VA: "Ciudad del Vaticano",
      VE: "Venezuela",
      VN: "Vietnam",
      YE: "Yemen",
      ZM: "Zambia",
      ZW: "Zimbabue"
    },

    warningTexts: {
      oAuth2: {
        usernameFormatError: "Ingrese el correo electrónico correctamente.",
        usernameInvalidException: "Usuario no registrado.",
        tokenExpired: "Sesión expirada. Inicie sesión nuevamente.",
        passwordFormatError: "La contraseña debe contener 8 caracteres.",
        passwordInvalidException: "Contraseña incorrecta. Intente nuevamente.",
      },

      signup: {
        confirmPassword: "Las contraseñas no coinciden. Intente nuevamente.",
        date: "Ingrese una fecha válida.",
        name: "Ingrese su {{id}} correctamente.",
        password: {
          beginning: "La contraseña debe contener al menos",
          length: "8 caracteres,",
          number: "un número,",
          uppercase: "una letra mayúscula,",
          lowercase: "una letra minúscula,",
          specialCharacter: "un carácter especial,",
        },
        select: "Ingrese un {{id}} válido.",
        username: "Ingrese un correo electrónico válido.",
        usernameAlreadyExistsError: "El usuario ya existe.",
        code: "Código inválido. Intente nuevamente.",
        acceptTerms: "Debe aceptar los términos de servicio.",
      },

      date: {
        year: "Ingrese un año válido.",
        month: "Ingrese un mes válido.",
        day: "Ingrese un día válido.",
        age: "Edad por debajo de la requerida.",
      },
    },
  },
};

export default esTranslations;
